import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/timetracker");
export const getTimeSheetExportPath = returnPath("/timetracker/time-sheet-export");
export const getTimeTrackerAdminPath = returnPath("/timetracker/time-tracker-admin");
